import Logo from "../../images/logo.png";
import { HiOutlineCheckCircle, HiOutlineXCircle } from 'react-icons/hi';
import { useHistory } from "react-router-dom";
import { ImSpinner8 } from "react-icons/im";
import useDocumentTitle from "../../Common/useDocumentTitle";

export default function Acknowledgement({ projectUploadFail, projectUploadLoading, uploadProgress, setProjectData, setStep, emptyProjectObject }) {
  useDocumentTitle("Acknowledgement");

  const history = useHistory();

  function calculatePercentage() {
    let percentage;
    percentage = (uploadProgress.loaded * 100) / uploadProgress.total;
    percentage = Math.floor(percentage);
    return percentage;
  }

  function getCurrentStatus() {
    // UPLOAD LOADING ---------------------------------------------------------------
    if (projectUploadLoading) {
      return (
        <>
          <div className="flex flex-col h-screen items-center">
            <div className="m-auto bg-gray-100 dark:bg-gray-800 rounded-xl mx-2">
              <div className="px-8 py-6 md:py-8 md:px-12">

                <span className="flex justify-center">
                  {/* <HiOutlineCheckCircle className="w-32 h-32 mx-auto text-green-500" /> */}
                  <ImSpinner8 className="w-12 h-12 mx-auto text-blue-600 animate-spin" />
                </span>

                <h1 className="mt-3 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl text-center">
                  Uploading Your Submission
                </h1>

                <p className="text-gray-700 dark:text-gray-300 text-md sm:text-lg text-center mt-2">Please wait as this can take a while.</p>

                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-4 mt-12 mb-4">
                  <div className="bg-blue-600 h-4 rounded-full" style={{ width: `${calculatePercentage()}%` }}></div>
                  <p className="text-center text-gray-900 dark:text-gray-100 font-medium">{calculatePercentage()}%</p>
                </div>

              </div>
            </div>
            <img
              className="mb-10 h-16 dark:invert"
              src={Logo}
              alt="Arctic Research Foundation Logo"
            />
          </div>
        </>
      );
    }
    // FAILED UPLOAD ---------------------------------------------------------------
    if (projectUploadFail) {
      return (
        <>
          <div className="flex flex-col h-screen items-center">
            <div className="m-auto bg-gray-100 dark:bg-gray-800 rounded-xl mx-2">
              <div className="px-8 py-6 md:py-8 md:px-12">
                <span className="flex justify-center">
                  <HiOutlineXCircle className="w-32 h-32 mx-auto text-red-500 dark:text-red-400" />
                </span>

                <h1 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl text-center">
                  Submission Failed
                </h1>

                <p className="text-gray-700 dark:text-gray-300 text-md sm:text-lg text-center mt-2">There was an error uploading your submission.</p>

                <div className="mt-16">
                  <button
                    onClick={() => { setStep(5); }}
                    type="button"
                    className="inline-flex items-center justify-center rounded-md w-full bg-blue-600 py-2.5 text-md font-semibold text-white shadow-sm hover:bg-blue-500 dark:hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Try Again
                  </button>
                  <button
                    onClick={() => { history.push("/") }}
                    type="button"
                    className="mt-3 inline-flex items-center justify-center rounded-md w-full bg-gray-300 dark:bg-gray-700 py-2.5 text-md font-semibold text-gray-700 dark:text-gray-300 shadow-sm hover:bg-gray-400 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
            <img
              onClick={() => { history.push("/") }}
              className="mb-10 h-16 cursor-pointer dark:invert"
              src={Logo}
              alt="Arctic Research Foundation Logo"
            />
          </div>
        </>
      )
    }
  }
  // SUCCESSFULL UPLOAD ---------------------------------------------------------------
  if (!projectUploadLoading && !projectUploadFail) {
    return (
      <>
        <div className="dark:bg-gray-900">
        <div className="flex flex-col h-screen items-center">
          <div className="m-auto max-w-lg mx-2">
            <div className="bg-gray-100 dark:bg-gray-800 rounded-xl px-8 py-6 md:py-8 md:px-12">
              <span className="flex justify-center">
                <HiOutlineCheckCircle className="w-32 h-32 mx-auto text-green-500 dark:text-green-400" />
              </span>

              <h1 className="mt-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl text-center">
                Submission Successful
              </h1>

              <p className="text-gray-700 dark:text-gray-300 text-md sm:text-lg text-center mt-2">Your contribution is under review.</p>

              <div className="mt-16">
                <button
                  onClick={() => { history.push("/profile?tab=My+Contributions") }}
                  type="button"
                  data-cy="view-contributions"
                  className="inline-flex items-center justify-center rounded-md w-full bg-blue-600 py-2.5 text-md font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:hover:bg-blue-700"
                >
                  View My Contributions
                </button>
                <button
                  onClick={() => { setProjectData(emptyProjectObject); setStep(1); }}
                  type="button"
                  className="mt-3 inline-flex items-center justify-center rounded-md w-full bg-gray-300 dark:bg-gray-700 py-2.5 text-md font-semibold text-gray-700 dark:text-gray-300 shadow-sm hover:bg-gray-400 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Submit Another Dataset
                </button>
              </div>

              <div className="mt-6">
                <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-base text-center mt-2">Want to showcase images, videos, and PDFs along with your metadata? <a href="/visualization" className="text-blue-700 font-medium hover:underline break-words">Add Visualization &rarr;</a></p>{/* rawr */}
              </div>
            </div>
          </div>
          <img
            onClick={() => { history.push("/") }}
            className="mb-10 h-16 cursor-pointer dark:invert"
            src={Logo}
            alt="Arctic Research Foundation Logo"
          />
        </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="dark:bg-gray-900">
        {getCurrentStatus()}
      </div>
    </>
  );
}